import { inject } from "mobx-react";

import { ResponsiveImage } from "../../../../core/components/ResponsiveImage.component";
import type { FeedResultFragment } from "@ihr-radioedit/inferno-webapi";
import { trimText } from "../../../../core/lib/utilities";
import { formatImage } from "@ihr-radioedit/inferno-core";
import { MagicLink } from "../../../../core/ui";
import { CoastFeedItemType, getCoastFeedImg } from "../../lib/coastFeed";
import { isPublishRecord, RESPONSIVE_IMAGE, reverseRoute } from "@inferno/renderer-shared-core";
import type { Store } from "@inferno/renderer-shared-core";

interface CoastFeedPhotoItemProps {
  item: FeedResultFragment;
  store?: Store;
}

export const CoastFeedPhotoItem = inject("store")(({ item, store }: CoastFeedPhotoItemProps) => {
  if (!store || !isPublishRecord(item.record)) {
    return null;
  }

  const { slug, payload } = item.record;
  const { summary } = payload;

  const thumb = formatImage(summary.image.url, store.env.IMAGE_HOST);
  const { imgSrc, srcset } = getCoastFeedImg(thumb, CoastFeedItemType.PHOTO, { quality: 80 });

  const photoUrl = reverseRoute(store.site, "photos_detail", { slug }) || "#";

  return (
    <figure className="coast-feed-item">
      <section className="item-thumb">
        <MagicLink to={photoUrl} context={slug}>
          <ResponsiveImage
            alt={summary.image.alt_text || summary.title}
            src={imgSrc}
            srcset={srcset}
            initialWidth={RESPONSIVE_IMAGE.responsiveImageInitialWidth}
            initialHeight={RESPONSIVE_IMAGE.responsiveImageInitialHeight}
          />
        </MagicLink>
      </section>
      <figcaption>
        <MagicLink className="item-title" to={photoUrl} context={slug}>
          {trimText(summary.title, 66)}
        </MagicLink>
      </figcaption>
    </figure>
  );
});

export default CoastFeedPhotoItem;
